angular.module('wbDashboard').controller('PortfolioplusDetailControllerAurea', ['$scope', '$uibModal', '$filter', '$timeout', '$window', 'User', 'Account', 'PlanService', 'ThinkingService', function ($scope, $uibModal, $filter, $timeout, $window, User, Account, PlanService, ThinkingService) {

    $scope.tabs = {
        active: 'portfolio',
        scrollTop: true,
        data: {
            "portfolio" : {label: 'Portfolio', value: 'portfolio', callbacks: {
                    beforeEnter: function() {
                        $window.Waypoint.destroyAll();
                    },
                    afterEnter: function(oldTab, newTab) {
                        $timeout(function() {
                            $window.Waypoint.refreshAll();
                            $scope.$apply();
                        }, 100);
                    }}},
            "past" : {label: 'Past', value: 'past', hidden: true, callbacks: {
                    afterEnter: function(oldTab, newTab) {
                        angular.element($window).trigger('resize');
                    }
                }},
            "edit" : {label: 'Edit', value: 'edit'}
        }
    };

    $scope.pageData.hoverData = {};

    $scope.portfolioPositions = null;
    $scope.portfolioAllocation = null;
    $scope.portfolioHistorical = null;

    $scope.$watch(function() { return PlanService.user.getPortfolios($scope.$stateParams.slug); }, function(portfolio) {
        if (portfolio && portfolio.slug === $scope.$stateParams.slug) {
            $scope.portfolio = portfolio;
        } else {
            $scope.$state.go('base.plans.custom.portfolioplus', {location: 'replace'});
        }
    });

    PlanService.user.retrievePortfolioPositions($scope.$stateParams.slug);
    $scope.$watch(function () { return PlanService.user.getPortfolioPositions($scope.$stateParams.slug); }, function (portfolioPositions) {

        if (portfolioPositions) {
            var targetPositions = angular.copy(portfolioPositions);
            $scope.portfolioPositions = portfolioPositions;

            targetPositions.positions.length = 0;
            targetPositions.market_value = null;
            angular.forEach(targetPositions.asset_classes, function(asset) {
                if (asset.target_allocation_rate === 0) {
                    return;
                }
                targetPositions.positions.push({
                    name: asset.name,
                    asset_class: asset.code,
                    ticker: asset.code,
                    category: asset.category,
                    allocation_rate: asset.target_allocation_rate
                });
            });
            targetPositions.actual_bond_rate = targetPositions.target_bond_rate;
            targetPositions.actual_stock_rate = targetPositions.target_stock_rate;

            $scope.portfolioAllocation = PlanService.user.formatPortfolioAllocation(targetPositions);

            $scope.portfolioPositions.cash_value = $scope.portfolioAllocation.cash_value;


        }

    });

    PlanService.user.retrievePortfolioMetrics($scope.$stateParams.slug);
    $scope.$watch(function () { return PlanService.user.getPortfolioMetrics($scope.$stateParams.slug); }, function (portfolioMetrics) {
        if (portfolioMetrics) {
            $scope.portfolioMetrics = portfolioMetrics;

            if (portfolioMetrics.historical_values.length) {
                angular.forEach(portfolioMetrics.historical_values, function(point) {
                    point.account_value = point.market_value;
                });
                $scope.portfolioHistorical = Account.returnsHistoricalParse([portfolioMetrics]);
                $scope.tabs.data.past.hidden = false;
            }
        }
    });




}]);
